module.exports = __webpack_public_path__ + "static/WATAN-b716fb43669dbb445ccda08bea34da86.jpg";